import fetch from '@/config/fetch';

// 获取验证图片  以及token
export function reqGet(data) {
  return fetch('/api/admin/captcha/get', data, 'POST');
}

// 滑动或者点选验证
export function reqCheck(data) {
  return fetch('/api/admin/captcha/check', data, 'POST');
}




// WEBPACK FOOTER //
// ./src/components/verifition/api/index.js